import type { CsvImportWizardConfig } from '../../components/common';

const RSVP_VALUES = ['invited', 'confirmed', 'declined', 'maybe'] as const;
const SIDE_VALUES = ['bride', 'groom', 'mutual', 'other'] as const;

export const guestImportConfig: CsvImportWizardConfig = {
  entity: 'guest',
  title: 'Import Guests from CSV',
  fields: [
    {
      key: 'firstName',
      label: 'First Name',
      type: 'string',
      required: true,
      aliases: ['first', 'given name', 'name'],
    },
    {
      key: 'lastName',
      label: 'Last Name',
      type: 'string',
      aliases: ['last', 'surname', 'family name'],
    },
    {
      key: 'familyGroup',
      label: 'Family Group',
      type: 'string',
      aliases: ['family', 'household', 'group'],
    },
    {
      key: 'side',
      label: 'Side',
      type: 'enum',
      enumValues: SIDE_VALUES,
      aliases: ['affiliation'],
    },
    { key: 'phone', label: 'Phone', type: 'string', aliases: ['mobile', 'cell', 'tel'] },
    { key: 'email', label: 'Email', type: 'string', aliases: ['email address', 'mail'] },
    {
      key: 'rsvpStatus',
      label: 'RSVP Status',
      type: 'enum',
      enumValues: RSVP_VALUES,
      aliases: ['rsvp', 'status'],
    },
    {
      key: 'mealPreference',
      label: 'Meal Preference',
      type: 'string',
      aliases: ['meal', 'food'],
    },
    { key: 'dietaryNotes', label: 'Dietary Notes', type: 'string', aliases: ['dietary', 'diet'] },
    {
      key: 'maleCount',
      label: 'Male Count',
      type: 'number',
      aliases: ['males', 'men', 'adult males'],
    },
    {
      key: 'femaleCount',
      label: 'Female Count',
      type: 'number',
      aliases: ['females', 'women', 'adult females'],
    },
    {
      key: 'kidCount',
      label: 'Kid Count',
      type: 'number',
      aliases: ['kids', 'children', 'child', 'minors'],
    },
    {
      key: 'keepTogether',
      label: 'Keep Together',
      type: 'boolean',
      aliases: ['together', 'same table'],
    },
    {
      key: 'tableNumber',
      label: 'Table Number',
      type: 'number',
      aliases: ['table'],
    },
    { key: 'notes', label: 'Notes', type: 'string' },
  ],
};
